import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { http } from "@/lib/http"
import { qk } from "@/lib/query-keys"
import type { components } from "@/types/api.gen"

import type { ReviewId } from "../../data/review-data"
import type { ReviewDocumentEntry } from "../report-data"

type WireReviewDocument = components["schemas"]["ReviewDocumentOut"]

export function fromWireReviewDocument(w: WireReviewDocument): ReviewDocumentEntry {
  return {
    role: w.role,
    isGoverning: w.is_governing,
    filename: w.document?.filename ?? null,
  }
}

/**
 * `GET /reviews/{id}/documents`: the FPL, every candidate master and the
 * auxiliary inputs. The report reads it for the filenames its own master
 * block and the FPL do not carry.
 */
export function useReviewDocumentsQuery(
  reviewId: ReviewId | null,
): UseQueryResult<ReviewDocumentEntry[]> {
  return useQuery({
    queryKey: reviewId != null ? qk.reviews.documents(reviewId) : ["reviews", "documents", "none"],
    queryFn: async ({ signal }) => {
      const wire = await http.get<WireReviewDocument[]>(
        `/api/v1/reviews/${encodeURIComponent(reviewId ?? "")}/documents`,
        { signal },
      )
      return wire.map(fromWireReviewDocument)
    },
    enabled: reviewId != null,
  })
}
